export default __webpack_public_path__ + "static/media/rocket.b11ea76b.svg";